import { VerticalAlignmentEnum } from '@models/common.model';

// ENUMS #############################################################


// INTERFACES ########################################################
export class IButtonGroupConfig {
	items: ButtonGroupItemType[];
	isDisabled?: boolean;
	isHidden?: boolean;
	isRenderable?: boolean;
}

export interface IButtonGroupItemBase {
	enforceLabelAppendedCustomTemplate?: boolean;
	enforceLabelCustomTemplate: boolean;
	enforceLabelPrependedCustomTemplate?: boolean;
	id: string;
	isDisabled?: boolean;
	isHidden?: boolean;
	isRenderable?: boolean;
	isSelected?: boolean;
	order: number;
	verticalAlignment?: VerticalAlignmentEnum;
	tooltip?: string;
}

export interface IButtonGroupItemLabelTemplateNotEnforced extends IButtonGroupItemBase {
	enforceLabelCustomTemplate: false;
	label: string;
}

export interface IButtonGroupItemLabelTemplateEnforced extends IButtonGroupItemBase {
	enforceLabelCustomTemplate: true;
}


// TYPES #############################################################
export type ButtonGroupItemType =
	IButtonGroupItemLabelTemplateNotEnforced
	| IButtonGroupItemLabelTemplateEnforced;
